import { useAnimateIntegrationsIllustration } from 'src/hooks/useAnimateIntegrationsIllustration';

import { StyledIntegrationIllustrationCard } from './LimitationModal.styles';

export const LimitationIntegrationCard = () => {
  const props = useAnimateIntegrationsIllustration();
  return <StyledIntegrationIllustrationCard {...props} />;
};
